import axios from 'axios';
import Message from '@/plugins/message';
import store from '@/store';
import { getToken, getRefreshToken } from '@/utils/auth';
import getUserFingerprint from '@/utils/user-finger-print.js';
import MyLog from '@/utils/my-log';

// create an axios instance
axios.defaults.timeout = 0; // 请求超时时间
axios.defaults.baseURL = process.env.VUE_APP_BASE_API;

// request interceptor
axios.interceptors.request.use(
  config => {
    // do something before request is sent
    const token = getToken();
    const refreshToken = getRefreshToken();
    const userInfo = store.state.app.userInfo;
    const comm_params = {
      platform: '1',
      region: store.state.app.region || 'TW',
      deviceId: getUserFingerprint()
    };
    config.headers['token'] = token || -1;
    if (refreshToken) {
      config.headers['refresh_token'] = refreshToken;
    }
    if (userInfo && userInfo.uuid) {
      comm_params.uuid = userInfo.uuid;
    }
    config.headers['comm_params'] = encodeURIComponent(
      JSON.stringify(comm_params)
    );
    return config;
  },
  error => {
    console.log(error);
    // do something with request error
    return Promise.reject(error);
  }
);

// response interceptor
axios.interceptors.response.use(
  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data;
    // if the custom code is not 20000, it is judged as an error.
    if (
      res.code == 9000 &&
      response.config &&
      response.config.url == '/voiceRoom/manager/adminList'
    ) {
      let data = JSON.parse(JSON.stringify(res).replace(/TWD/g, '$'));
      return data;
    }
    if (res.code !== 200) {
      // const { userInfo } = store.getters;
      try {
        delete response.config.headers;
        MyLog.captureException('httpError', {
          tags: {
            httpCode: res.code
          },
          context: response
        });
        console.log(response.data,response.request.responseURL)
      } catch (error) {
        console.log(error);
      }
      try {
        if (
          response &&
          response.config &&
          response.config.url &&
          response.config.url != '/basic/front/error'
        ) {
          const { userInfo } = store.getters;
          delete response.config.headers;
          const errorData = {
            error: response,
            time: new Date().toISOString().slice(0, 19),
            errorType: 'response',
            userId: userInfo && userInfo.uuid ? userInfo.uuid || '' : ''
          };
          post('/basic/front/error', {
            message: JSON.stringify(errorData)
          })
        }
      } catch (error) {
        console.log(error);
      }

      if ([423, 452, 4001, 4002].includes(res.code)) {
        // 4000: Illegal token; 4001: Other clients logged in; 4002: Token expired;
        // to re-login
        store.dispatch('app/resetToken').then(() => {
          // location.reload()
        });
      } else {
        const stringCode = res.code + '';
        const code = stringCode.charAt(0);
        if (code === '5') {
          Message({
            message: '系統異常',
            type: 'error',
            duration: 3000
          });
        }
      }
      return Promise.reject(res);
    } else {
      let data = JSON.parse(JSON.stringify(res).replace(/TWD/g, '$'));
      return data;
    }
  },
  error => {
    MyLog.captureException('httpError', {
      context: error
    });
    // 取消http请求不用弹窗提示
    if (error.message !== 'canceled') {
      try {
        if (
          error &&
          error.config &&
          error.config.url &&
          error.config.url != '/basic/front/error'
        ) {
          const { userInfo } = store.getters;
          delete error.config.headers;
          const errorData = {
            error: error,
            time: new Date().toISOString().slice(0, 19),
            errorType: 'responseError',
            userId: userInfo && userInfo.uuid ? userInfo.uuid || '' : ''
          };
          post('/basic/front/error', {
            message: JSON.stringify(errorData)
          }).then(res => {
            console.log(res);
          });
        }
      } catch (error) {
        console.log(error);
      }
      // 用户网络错误时不弹窗
      // Message({
      //   message: error.message,
      //   type: 'error',
      //   duration: 5 * 1000
      // });
    }
    return Promise.reject(error);
  }
);
/**
 * 封装get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
function get(url, params = {}, config = {}) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, { params, ...config })
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}
/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
function post(url, params, config) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, params, config)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}

function request(config) {
  return axios.request(config);
}
export { get, post, request };
